<template>
	<div class="benefit">
		<div class="benefit-header">
			<div class="benefit-header__title"></div>
			<div class="benefit-header__title-sub"></div>
		</div>
		<div class="benefit-content">
			<div :class="[ 'content__item', (!hasRight || benefit.stock === 0) && 'benefit-content__item--empty'
        ]" v-for="benefit in benefitList" :key="benefit.id" @click="onItemClick(benefit)">
				<img :src="`${imgPrefix}${benefit.thumbnailUrl}`" />
			</div>
		</div>
	</div>
</template>

<script>
	import {
		reactive,
		toRef,
		onMounted
	} from 'vue'
	import {
		Dialog
	} from 'vant'
	import {
		useRoute,
		useRouter
	} from 'vue-router'
	import globalVariables from '@/utils/globalVariables'
	import api from '@/api'

	export default {
		setup() {
			const router = useRouter()
			const route = useRoute()
			const {
				activityCode
			} = route.query
			const data = reactive({
				benefitList: [],
				hasRight: true,
				isMessage:"",
			})

			const onItemClick = benefit => {
				if (!data.hasRight) {
					Dialog.alert({
						message: data.isMessage
					})
					return
				}
				if (benefit.stock === 0) {
					Dialog.alert({
						message: '该商品已售罄'
					})
					return
				}
				router.push({
					path: '/productDetail',
					query: {
						id: benefit.id,
						activityCode
					}
				})
			}

			onMounted(() => {
				document.title = ''
				api
					.getProductList({
						activityCode
					})
					.then(res => {
						data.benefitList = res.data
					})

				api
					.isHaveRight({
						activityCode
					})
					.then(res => {
						const {
							status,
							message
						} = res.data
						if (status === -1) {
							data.hasRight = false
							data.isMessage=message
							Dialog({
								title: '友情提醒',
								message
							})
						}
					})
			})
			return {
				imgPrefix: globalVariables.imgPrefix,
				benefitList: toRef(data, 'benefitList'),
				isMessage: toRef(data, 'isMessage'),
				hasRight: toRef(data, 'hasRight'),
				onItemClick
			}
		}
	}
</script>

<style lang="less" scoped>
	.benefit {
		min-height: 100vh;
		background: #930505;

		background-image: url('../../assets/benefit-back.png'),
			url('../../assets/benefit-back-radiate.png');
		background-repeat: repeat, no-repeat;
		background-size: 100%;
		background-position: left top, center -120px;

		.benefit-header {
			overflow: hidden;

			.benefit-header__title {
				width: 286px;
				height: 70px;
				background-image: url('../../assets/benefit-title.png');
				background-repeat: no-repeat;
				background-size: 100%;
				margin: 24px 0 0 44px;
			}

			.benefit-header__title-sub {
				width: 235px;
				height: 39px;
				background-image: url('../../assets/benefit-title-sub.png');
				background-repeat: no-repeat;
				background-size: 100%;
				margin: 1px 0 0 70px;
			}
		}

		.benefit-content {
			display: flex;
			flex-wrap: wrap;
			margin-top: 9px;
			padding-bottom: 30px;

			.content__item {
				width: 161px;
				height: 85px;
				margin-top: 18px;
				margin-left: 18px;

				img {
					width: 161px;
					height: 85px;
				}
			}

			.benefit-content__item--empty {
				img {
					filter: grayscale(100%);
				}
			}
		}
	}
</style>
